import { useGraphqlQuery } from "@bsm/component"
import { TUserStudentScholarity } from "@bsm/graphql"
import { ScholarityQuery } from "../queries/ScholarityQuery"

export const useScholarityQuery = (id?: number, suspense?: boolean) => {
    return useGraphqlQuery<ScholarityQuery, TUserStudentScholarity>(new ScholarityQuery({ id }), { enabled: id !== undefined, suspense })
}
